import React, { useState, useEffect, useRef } from 'react'
import './index.scss'
import classnames from 'classnames'
// import ImgLoading from '../imgLoading/index';
import LazyLoad from 'react-lazyload'
import { useTranslation } from '../../i18n'
/**
 * @param images 默认取第一张
 */
const getImgPath = (images: any[]) => {
  if (images === void 0 || images.length === 0) {
    return ''
  }
  if (images[0].thumbnail !== void 0 && images[0].thumbnail.url !== void 0) {
    return images[0].thumbnail.url + '?x-oss-process=image/resize,l_500'
  } else if (images[0].full !== void 0 && images[0].full.url !== void 0) {
    return images[0].full.url + '?x-oss-process=image/resize,l_500'
  }
  return ''
}

const badgeMap = {
  TOP: '',
  HOT: '热',
  NEW: '新',
  HOLD: '顶',
  WORTH: '值',
  SPIKE: '秒',
  EXCLUSIVE: '独家',
  POSTAGE_REDUCTION: '减邮',
  FREE_SHIPPING: '免邮',
}
const getUrl = (type?: Badge, value?: number) => {
  if(type) {
    if(type === 'TOP') {
      const path = value > 3 ? '': value
      return `http://baleen-cdn-g.bybieyang.com//static/images/brandGame/ic_${path}@2x.png`
    }else {
      return 'http://baleen-cdn-g.bybieyang.com//static/images/brandGame/ic_1@2x.png'
    }
  }
}
export interface IImageModel {
  full?: any
  thumbnail?: any
}

export interface IProductModel {
  images: IImageModel[]
  id: string
  name: string
  nameCN?: string
  colors: any[]
  displayBrand?: string
  brand: string
  originalPriceTag: string
  priceTagCN: string
  priceTag: string
  inventoryStatus: string
  type: string
  shortTitle?: string
  officialURL?: string
}
interface IlabelDetail {
  text: string
  color: string
  backgroundColor: string
  fontsize: number
  fontWeight: string
}
interface IlabelItem {
  labels?: IlabelDetail[]
  layers?: string[]
  kind?: string
}
interface Ilabel {
  shortLabels: IlabelItem[]
}
export interface IRankProdutModel {
  product: IProductModel
  origin: string
  merchantName: string
  favoritedCount: number
  activityOffs: string[]
  off?: string[]
  labelView?: Ilabel
}
type Badge = "TOP" | "HOT" | "NEW" | "HOLD" |"WORTH" | "SPIKE" | "EXCLUSIVE" | "POSTAGE_REDUCTION" | "FREE_SHIPPING"
interface IProps {
  productInfo: IRankProdutModel
  className: string
  clickTo: (name, id, path2, pid, officialURL?: string) => void
  pid?: string
  index?: number
  meta?: {
    badge?: {
      type: Badge
      value: number
    }
  }
}

const Product1: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation()
  const mounted: any = useRef()
  const { productInfo, className, clickTo, pid, index } = props
  const meta = props.meta || {}
  const { product } = productInfo
  const classes = classnames('lego_Product1', className)
  const productName =
    (product.displayBrand
      ? `${product.displayBrand} | `
      : `${product.brand} | `) + (product.nameCN || product.name)
  return (
    <div
      ref={mounted}
      className={classes}
      onClick={() =>
        clickTo('product', product.id, '', pid, product.officialURL)
      }
      data-productid={product.id}
      data-index={index}
      data-pid={pid}
      data-id={product.id}
    >
      <div className="product1_imgBox">
        <LazyLoad
          overflow={true}
          height={100}
          classNamePrefix="product1_imgBox_img"
        >
          <img src={getImgPath(product.images)} />
        </LazyLoad>
        {product.inventoryStatus !== 'AVAILABLE' && (
          <div className="selloutContent">{t('SOLD_OUT')}</div>
        )}
      </div>
      {meta?.badge?.type && (
        <div
          className={[
            'badge',
            meta.badge?.type === 'TOP' && meta.badge?.value > 3
              ? 'default'
              : '',
          ].join(' ')}
        >
          <img src={getUrl(meta.badge?.type, meta.badge?.value)} alt="" />
          {(() => {
            const type = meta.badge?.type
            switch (type) {
              case 'TOP':
                const value = meta.badge?.value
                return (
                  <p className={['top', value > 3 ? 'default' : ''].join(' ')}>
                    {value <= 3 && <span>TOP</span>}
                    <span>{meta.badge?.value}</span>
                  </p>
                )
              case 'HOT':
              case 'NEW':
              case 'HOLD':
              case 'SPIKE':
              case 'WORTH':
                return <p className="one">{badgeMap[type]}</p>
              case 'EXCLUSIVE':
              case 'POSTAGE_REDUCTION':
              case 'FREE_SHIPPING':
                return <p>{badgeMap[type]}</p>
              default:
                return null
            }
          })()}
        </div>
      )}
      <div className="info-content">
        {product.shortTitle && (
          <div className="short-title text-overflow">{product.shortTitle}</div>
        )}

        <div
          className={
            product.shortTitle
              ? `product-name text-overflow`
              : `short-title text-box2`
          }
        >
          {productName}
        </div>
        <div className="product-price">
          <div className="price-wrapper">
            <div className="price">
              <span className="text-overflow">{product.priceTagCN}</span>
              <span className="text-overflow">{product.priceTag}</span>
            </div>
            {product.originalPriceTag && (
              <div className="result">{t('FINAL_PRICE')}</div>
            )}
          </div>
          <div
            className={product.originalPriceTag ? 'origin-price' : 'buy-btn'}
          >
            {product.originalPriceTag ? product.originalPriceTag : t('BUY_NOW')}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Product1
